import { render, staticRenderFns } from "./AccountDeleteDialog.vue?vue&type=template&id=93b0d51a"
import script from "./AccountDeleteDialog.vue?vue&type=script&lang=js"
export * from "./AccountDeleteDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports